<script>
export default {
  name: 'CardCarcass',
}
</script>

<template>
  <div class="shadow-card rounded mt-4 p-2">
    <slot></slot>
  </div>
</template>

<style scoped>
.shadow-card {
  box-shadow: 0 1px 5px 0 #00000024;
}
</style>
